import { LocaleEnum } from '@systemeio/ui-frontend'

// TODO: remove
export const getCalculatedLanguage = (language: string): string => {
  let readableLanguage
  switch (language) {
    case LocaleEnum.JAPANESE: {
      readableLanguage = 'jp'
      break
    }
    default: {
      readableLanguage = language
    }
  }

  return readableLanguage.toUpperCase()
}
